import useAxios from '../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchAllImages = createAsyncThunk('gallery/fetchAllImages',({limit, offset},{ rejectWithValue }) => {
    const api = useAxios();
    return api
      .get(`api/admin/gallery/images?limit=${limit}&offset=${offset}`)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})


export const uploadImage = createAsyncThunk('gallery/uploadImage', (data, { rejectWithValue }) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data;"
    },
    onUploadProgress: (progressEvent) => {
      const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
      console.log('Upload progress:', progress);
    }
  };

  const api = useAxios();
  return api
    .post(`api/admin/gallery/upload_image`, data, config)
    .then(response => response.data)
    .catch(error => rejectWithValue(error))
})

export const deleteImage = createAsyncThunk('gallery/deleteImage', (imageId, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .delete(`api/admin/gallery/${imageId}/delete_image/`)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})

export const updateImage = createAsyncThunk('gallery/updateImage', ({ imageId, data }, { rejectWithValue }) => {
    const api = useAxios();
    return api
      .patch(`api/admin/gallery/${imageId}/update_image/`, data)
      .then(response => response.data)
      .catch(error => rejectWithValue(error))
})